import React, { useState } from 'react';
import { images } from '../../constants'
import { HiExternalLink } from 'react-icons/hi';
import testimonial from '../../data/testimonial.json';
import { AppWrap } from '../../wrapper';
import './Testimonial.scss';
import Button from "./Button/Button"
const Testimonial = () => {
  const info = testimonial

const [currentTestimonial, setCurrentTestimonial] = useState(0);

    const goToPreviousTestimonial = () => {
        const isFirstTestimonial = currentTestimonial === 0
        const newTestimonial = isFirstTestimonial ? info.length -1 : currentTestimonial -1
        setCurrentTestimonial(newTestimonial)

    }

    const goToNextTestimonial = () => {
        const isLastTestimonial = currentTestimonial === info.length -1
        const newTestimonial = isLastTestimonial ? 0 : currentTestimonial + 1
        setCurrentTestimonial(newTestimonial)
    }

    return (
        <>
        <h2 style={{color:"var(--primary-color)"}}>Testimonial</h2> 
            <section key={info[currentTestimonial].id} className={"testimonials"}>
                <div className={"container"}>
                    
                    <div className={"img_container"} >
                        <figure className={"portrait"}>
                            <img loading="lazy" src={images[info[currentTestimonial].img]} alt={info[currentTestimonial].alt_img} />
                            <nav className={"nav_button"}>
                                <Button previousTestimonial={goToPreviousTestimonial} nextTestimonial={goToNextTestimonial} />
                            </nav>
                        </figure>
                    </div>

                    <div className={"info_container"}>
                        <p className={"bio"}> {info[currentTestimonial].info} </p>
                        <div className={"personal_data"}>
                            <h3 className={"name"} > {info[currentTestimonial].name} </h3>
                            <h4 className={"profession"} > {info[currentTestimonial].profession} </h4>
                            {info[currentTestimonial].recommendationUrl && (
                                <a
                                    className={"recommendation_link"}
                                    href={info[currentTestimonial].recommendationUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Recommendation
                                    <HiExternalLink />
                                </a>
                            )}
                        </div>
                    </div>

                </div>
            </section>
            
        </>
    )

};

export default AppWrap(Testimonial, 'testimonial');
